function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8438 7.125H12.25V4.75C12.25 2.13038 10.1196 0 7.5 0C4.88037 0 2.75 2.13038 2.75 4.75V7.125H2.15625C1.17458 7.125 0.375 7.92379 0.375 8.90625V17.2188C0.375 18.2012 1.17458 19 2.15625 19H12.8438C13.8254 19 14.625 18.2012 14.625 17.2188V8.90625C14.625 7.92379 13.8254 7.125 12.8438 7.125ZM4.33333 4.75C4.33333 3.00358 5.75358 1.58333 7.5 1.58333C9.24642 1.58333 10.6667 3.00358 10.6667 4.75V7.125H4.33333V4.75ZM8.29167 13.2383V15.0417C8.29167 15.4787 7.93779 15.8333 7.5 15.8333C7.06221 15.8333 6.70833 15.4787 6.70833 15.0417V13.2383C6.23729 12.9635 5.91667 12.4585 5.91667 11.875C5.91667 11.0018 6.62679 10.2917 7.5 10.2917C8.37321 10.2917 9.08333 11.0018 9.08333 11.875C9.08333 12.4585 8.76271 12.9635 8.29167 13.2383Z",
  fill: "#7E8897"
});

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b6e60c45.svg";
export { ForwardRef as ReactComponent };